var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 510.5,
    cy: 131.5,
    r: 62.5,
    fill: "#17C7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.759 315.591C236.021 347.651 310.373 325.009 342.828 265.019C375.282 205.029 353.55 130.405 294.288 98.3447C235.026 66.2843 160.674 88.927 128.22 148.917C95.7659 208.907 117.497 283.531 176.759 315.591Z",
    fill: "url(#loaderGradient5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.126,
    cy: 619.5,
    rx: 165.5,
    ry: 163.5,
    transform: "rotate(-15.6547 352.126 619.5)",
    fill: "#ED801B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient5",
    x1: 194.736,
    y1: 212.322,
    x2: 358.271,
    y2: 193.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.22949039.svg";
export { ForwardRef as ReactComponent };